<div class="wrapper">
  <div class="content-left">
    <div class="content-text">
      <h1>Das Portal steht momentan nicht zur Verf&uuml;gung</h1>
      <p>
        Wir nehmen derzeit Verbesserungen am Portal vor.<br />
        Das kann etwas Zeit in Anspruch nehmen.<br /><br />
        Bitte versuchen Sie es später erneut.
      </p>
    </div>
  </div>
  <div class="content-right">
    <img src="/assets/maintenance.svg" alt="" />
  </div>
</div>
